import React, { useEffect } from 'react'
import Style from './ProductHomeSlider.module.css'
import SupplierSliderItem from '../../../Component/SupplierSliderItem/SupplierSliderItem';
import { useKeenSlider } from 'keen-slider/react';
import { addsupplierTofavorite, removeSupplierTofavorite } from '../../../Api/BarestServices';
import { Link } from 'react-router-dom';
import { faArrowLeft, faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const SupplierHomeSlider = ({title,sliderData,linkAddress}) => {
  const [sliderRef, sliderInstance] = useKeenSlider({
      mode: "free",
      loop:true,
      breakpoints: {
        "(min-width: 280px)": {
          slides: { perView: 2.5, spacing: 5 },
          rtl: true,
        },
        "(min-width: 600px)": {
          slides: { perView: 3.5, spacing: 5 },
          rtl: true,
        },
        "(min-width: 1000px)": {
          slides: { perView: 4.5, spacing: 5 },
          rtl: true,
        },
      },
      slides: { perView: 1 },
      rtl: true,
    });
      useEffect(() => {
        if (sliderInstance && sliderInstance.current) {
          const t = setTimeout(() => {
            try {
              sliderInstance.current.update();
            } catch (e) {
            }
          }, 50);
          return () => clearTimeout(t);
        }
      }, [sliderInstance, sliderData]);
      useEffect(() => {
          const interval = setInterval(() => {
            if (sliderInstance && sliderInstance.current) {
              try {
                sliderInstance.current.next();
              } catch (e) {
              }
            }
          }, 2000);
      
          return () => clearInterval(interval);
        }, [sliderInstance]);
    const addFavoriteHandler=()=>{
        // let supplierId={
        //   id:props.data.id
        // }
        // if(!gold)
        // {
        //   addsupplierTofavorite(supplierId,(res)=>{})
        // }
        // else{
        //   removeSupplierTofavorite(supplierId,(res)=>{})
          
        // }
      }
  return (
    <>
      <div className={Style.sliderTitleHolder}>
        <h3>{title}</h3>
        <Link to={`/${linkAddress}`}>
          دیدن همه 
          <FontAwesomeIcon icon={faChevronLeft} />
        </Link>
      </div>
      <div ref={sliderRef} className={`${Style.SliderSection} keen-slider`}>
        {sliderData?.map((item) => {
          return (
            <SupplierSliderItem item={item} key={item.id} 
            addFavorite={addFavoriteHandler}
            />
          );
        })}
      </div>
    </>
  )
}

export default SupplierHomeSlider